// extracted by mini-css-extract-plugin
export default {"info":"delete-role-modal_info__LX6st","text":"delete-role-modal_text__YtPFF","source":"delete-role-modal_source__3yaYD","button":"delete-role-modal_button__fpyxk"};